import { ReconMismatches } from '@src/containers/Blotters/Reconciliation/ReconMismatches';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { ReconMismatchesPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function ReconMismatchesPanel({ params, api }: LayoutPanelProps<ReconMismatchesPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.ReconMismatchesBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="recon-mismatches-panel"
      >
        <ReconMismatches />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
